import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import VerificaToken from "./VerificaToken";

function RimozioneAccount() {
  const { user, setUser } = VerificaToken();
  const [show, setShow] = useState(false);
  let history = useHistory();

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const eliminaAccount = () => {
    axios
      .delete(
        `https://website-8bit-motors.herokuapp.com/account/info/${user.id}/rimuoviAccount`
      )
      .then(() => {
        localStorage.clear();
        history.push("/");
      }).catch(() => {
        alert("Connessione Non Disponibile");
      });;
  };

  return (
    <>
      <Link onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-person-x"
          viewBox="0 0 16 16"
        >
          <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
          <path
            fillRule="evenodd"
            d="M12.146 5.146a.5.5 0 0 1 .708 0L14 6.293l1.146-1.147a.5.5 0 0 1 .708.708L14.707 7l1.147 1.146a.5.5 0 0 1-.708.708L14 7.707l-1.146 1.147a.5.5 0 0 1-.708-.708L13.293 7l-1.147-1.146a.5.5 0 0 1 0-.708z"
          />
        </svg>
        <h3>Elimina Account</h3>
        <p>Clicca qui per eliminare definitivamente il tuo account.</p>
      </Link>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Rimuovi Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Sei sicuro di volere eliminare il tuo account? QUESTA AZIONE È
          IRREVERSIBILE!
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No grazie.
          </Button>
          <Button variant="primary" onClick={eliminaAccount}>
            Sono Sicuro.
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RimozioneAccount;
